import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'

Styxie.Initializers.MlapProjectsTechnicians = routerStyxie({
  actions: ['index'],
  hydrate: (props, pinia) => useMlapProjectStore(pinia).hydrate(props.project)
})
